import api, { TipoOptions } from './api';
import { RegistroEsin204 } from './esin204';
import { Projeto, RequisitadoRc } from './projeto';
import {
  CicloOrcamentarioProjetoDadosGerais,
  CicloOrcamentarioProjetoPacote,
  CicloOrcamentarioRelatorio,
} from './relatorioCicloorcamentario';
import { ReportCapexManeger, ReportCicloOrcamentario } from './relatorios';
import { trackPromise } from 'react-promise-tracker';
import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { TabelaProjetoOverViewResult } from './tabelaProjetoOverView';

export interface FechamentoResult {
  versao: number;
  ano: number;
  mes: number;
  createdAtFormatado: string;
  index: number;
  status: string;
}

export interface FechamentoRegistroEsin204 {
  id: string;
  ano: number;
  resultAno: RegistroEsin204[];
  carregarMesAno: boolean;
  meses: string[];
}

export interface TotalProjeto {
  totalProjeto: number;
  numeroProjetoAtual: number;
  descricaoEtapa: string;
  codigoProjetoAtual: string;
}

export interface ProcessoRotinas {
  solicitarGeracaoDoRelatorioFechamento: boolean;
  fechamentoEmProcessamento: boolean;
}

export const getProcessoRotinas = () => api.get<ProcessoRotinas>(`routines/getProcessoRotinas`);

export const getFechamentoAtual = () => api.get<string>(`fechamento/getFechamentoAtual`);
export const getAllFechamento = () => api.get<FechamentoResult[]>(`fechamento/`);
export const solicitarGeracaoDoRelatorioFechamento = () => api.post(`fechamento/solicitarGeracaoDoRelatorioFechamento`);
export const resumoProcessoRotina = () => api.get<TotalProjeto>(`fechamento/resumoProcessoRotina`);

export const getFechamentoPluriAnualByFechamentoId = (fechamentoId: string) =>
  api.get<CicloOrcamentarioRelatorio>(`fechamento/getFechamentoPluriAnualByFechamentoId/${fechamentoId}`);
export const getFechamentoCicloAnoByFechamentoId = (fechamentoId: string) =>
  api.get<CicloOrcamentarioRelatorio>(`fechamento/getFechamentoCicloAnoByFechamentoId/${fechamentoId}`);
export const getFechamentoControleRfaByFechamentoId = (fechamentoId: string) =>
  api.get<CicloOrcamentarioRelatorio>(`fechamento/getFechamentoControleRfaByFechamentoId/${fechamentoId}`);
export const getFechamentoExecutiveSummaryByFechamentoId = (fechamentoId: string) =>
  api.get<ReportCapexManeger>(`fechamento/getFechamentoExecutiveSummaryByFechamentoId/${fechamentoId}`);
export const getFechamentoCurvaEconomicaByFechamentoId = (fechamentoId: string) =>
  api.get<ReportCicloOrcamentario>(`fechamento/getFechamentoCurvaEconomicaByFechamentoId/${fechamentoId}`);
export const getFechamentExecutadoByFechamentoId = (fechamentoId: string) =>
  api.get<FechamentoRegistroEsin204[]>(`fechamento/getFechamentExecutadoByFechamentoId/${fechamentoId}`);

export const getFechamentExecutadoMesAnoByFechamentoId = (fechamentoId: string, mes: string, ano: number) =>
  api.get<RegistroEsin204[]>(`fechamento/getFechamentExecutadoMesAnoByFechamentoId/${fechamentoId}/${mes}/${ano}`);
export const getFechamentoCicloOrcamentarioDadosGeraisProjetoDetalhe = (fechamentoId: string, projetoId: string) =>
  api.get<CicloOrcamentarioProjetoDadosGerais>(
    `fechamento/getFechamentoCicloOrcamentarioDadosGeraisProjetoDetalhe/${fechamentoId}/${projetoId}`,
  );

export const getFechamentoCicloAnoPacoteProjeto = (fechamentoId: string, projetoId: string) =>
  api.get<CicloOrcamentarioProjetoPacote>(`fechamento/getFechamentoCicloAnoPacoteProjeto/${fechamentoId}/${projetoId}`);
export const getFechamentoCicloAnoGraficoCurvaProjeto = (fechamentoId: string, projetoId: string) =>
  api.get<ReportCicloOrcamentario>(`fechamento/getFechamentoCicloAnoGraficoCurvaProjeto/${fechamentoId}/${projetoId}`);

export const getFechamentoPluriAnualPacoteProjeto = (fechamentoId: string, projetoId: string) =>
  api.get<CicloOrcamentarioProjetoPacote>(
    `fechamento/getFechamentoPluriAnualPacoteProjeto/${fechamentoId}/${projetoId}`,
  );
export const getFechamentoPluriAnualGraficoCurvaProjeto = (fechamentoId: string, projetoId: string) =>
  api.get<ReportCicloOrcamentario>(
    `fechamento/getFechamentoPluriAnualGraficoCurvaProjeto/${fechamentoId}/${projetoId}`,
  );

export const getFechamentoProjetoRequisitado = (fechamentoId: string, projetoId: string) =>
  api.get<RequisitadoRc[]>(`fechamento/getFechamentoProjetoRequisitado/${fechamentoId}/${projetoId}`);

export const getFechamentoProjetoRequisitadoComOrdemDeCompra = (fechamentoId: string, projetoId: string) =>
  api.get<RequisitadoRc[]>(`fechamento/getFechamentoProjetoRequisitadoComOrdemDeCompra/${fechamentoId}/${projetoId}`);
export const getFechamentoProjetoRequisitadoSemOrdemDeCompra = (fechamentoId: string, projetoId: string) =>
  api.get<RequisitadoRc[]>(`fechamento/getFechamentoProjetoRequisitadoSemOrdemDeCompra/${fechamentoId}/${projetoId}`);

export const exportarFechamentoCicloOrcamentario = (fechamentoId: any, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/fechamento/exportarFechamentoCicloOrcamentario/${fechamentoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadElementExportarFechamentoCicloOrcamentario');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElementExportarFechamentoCicloOrcamentario').outerHTML = '';
    }),
  );
};

export const exportarFechamentoCicloOrcamentarioProjetoPacote = (fechamentoId: any, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/fechamento/exportarFechamentoCicloOrcamentarioProjetoPacote/${fechamentoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadElementExportarFechamentoCicloOrcamentarioProjetoPacote');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElementExportarFechamentoCicloOrcamentarioProjetoPacote').outerHTML = '';
    }),
  );
};

export const exportarFechamentoPluriAnual = (fechamentoId: any, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/fechamento/exportarFechamentoPluriAnual/${fechamentoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadElementExportarFechamentoPluriAnual');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElementExportarFechamentoPluriAnual').outerHTML = '';
    }),
  );
};

export const exportarFechamentoProjetoPluriAnual = (fechamentoId: any, projetoId: any, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/fechamento/exportarFechamentoProjetoPluriAnualPacote/${fechamentoId}/${projetoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadExportarFechamentoProjetoPluriAnual');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadExportarFechamentoProjetoPluriAnual').outerHTML = '';
    }),
  );
};

export const exportarFechamentoProjetoCicloAnoPacote = (fechamentoId: any, projetoId: any, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/fechamento/exportarFechamentoProjetoCicloAnoPacote/${fechamentoId}/${projetoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadExportarFechamentoProjetoCicloAnoPacote');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadExportarFechamentoProjetoCicloAnoPacote').outerHTML = '';
    }),
  );
};

export const exportarFechamentoProjetoPluriAnualDetalado = (
  fechamentoId: any,
  projetoId: any,
  nomeDoArquivo: string,
) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/fechamento/exportarFechamentoProjetoPluriAnualDetalado/${fechamentoId}/${projetoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadExportarFechamentoProjetoPluriAnualDetalado');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadExportarFechamentoProjetoPluriAnualDetalado').outerHTML = '';
    }),
  );
};


export const getFechamentoReportPerformaceProject = (fechamentoId: string) => {
  return api.get<TabelaProjetoOverViewResult[]>(`fechamento/getFechamentoReportPerformaceProject/${fechamentoId}`);
}

export const getFechamentoReportPerformaceProjectDetalhe = (fechamentoId: string, projetoId: string) => {
  return api.get<Projeto>(`fechamento/getFechamentoReportPerformaceProjectDetalhe/${fechamentoId}/${projetoId}`);
}

export const exportarRelatorioProjetoOverFechamento = (fechamentoId: any, nomeDoArquivo: string,) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/fechamento/exportarRelatorioProjetoOverFechamento/${fechamentoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadExportarRelatorioProjetoOverFechamento');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadExportarRelatorioProjetoOverFechamento').outerHTML = '';
    }),
  );
};
